module.exports = "<div class=\"accordion\">\r\n  <ng-content></ng-content>\r\n</div>"